import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { pricingPlans, clients } from "../mock";
import ScheduleDemoCTA from "../components/ScheduleDemoCTA";

const MEETING_URL = "https://www.somm.ai/meeting";

export default function Pricing() {
  return (
    <div style={{ background: "#f5f6f8" }}>
      {/* Header */}
      <section className="max-w-7xl mx-auto px-6 pt-20 pb-10 text-center">
        <div className="text-[13px] font-semibold tracking-[0.14em] uppercase" style={{ color: "#2552ff" }}>pricing</div>
        <h1 className="hero-title mt-4 text-5xl md:text-6xl max-w-4xl mx-auto">Unlimited access at a price<br className="hidden md:block"/> that makes sense</h1>
        <p className="mt-5 text-lg text-[#4b5566]">Get unlimited markets, brands and users on all our plans.</p>
      </section>

      {/* Plans */}
      <section className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-6 mt-6 pb-10">
        {pricingPlans.map((p) => (
          <div key={p.name} className="price-card">
            <div className="text-2xl font-extrabold">{p.name}</div>
            <p className="mt-3 text-[15px] leading-relaxed text-[#4b5566]">{p.subtitle}</p>
            <div className="mt-7 flex items-baseline gap-1">
              <div className="text-sm text-[#7a8499]">Contact us for pricing</div>
            </div>
            <div className="mt-6 flex justify-center">
              <a
                href={MEETING_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-dark inline-flex items-center gap-2 px-6 py-3"
              >
                Get Pricing <ArrowRight size={16} />
              </a>
            </div>
            {p.prefix ? (
              <div className="mt-7 text-sm text-[#4b5566]">
                Everything in <span className="font-semibold">{p.prefix.replace("Everything in ", "").replace(", plus", "")}</span>, plus
              </div>
            ) : (
              <div className="mt-7" />
            )}
            <ul className="mt-4 space-y-3">
              {p.features.map((f) => (
                <li key={f} className="flex items-center gap-3">
                  <span className="w-5 h-5 rounded-full flex items-center justify-center shrink-0 bg-[#e8faef]">
                    <Check size={12} className="text-[#16a34a]" />
                  </span>
                  <span className="text-[15px]">{f}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      {/* Clients */}
      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center">
          <div className="eyebrow">Clients</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold">Don&apos;t take our word for it.</h2>
          <p className="mt-4 text-[#4b5566]">Our clients are highly-respected brands, importers and distributors of all sizes</p>
        </div>
        <div className="marquee mt-10">
          <div className="marquee-track">
            {[...clients, ...clients].map((c, i) => (
              <img key={i} src={c.logo} alt={c.name} className="h-10 md:h-12 object-contain grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all" />
            ))}
          </div>
        </div>
      </section>

      <ScheduleDemoCTA />
    </div>
  );
}
